import axios from 'axios'
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import env from '@/config'
import VueCookies from 'vue-cookies'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getHeaderSignature, toUniLogin, getUnisysid } from '@/utils/utils'

let userVidState = false // 获取vid接口只调用一次
let isHandling2009 = false // 处理2009状态码的标识符，防止重复处理
let pending2009Promise = null // 存储正在进行的2009处理Promise，用于并发请求等待
let isShowingError = false // 防止重复显示错误消息

const showErrorOnce = (msg) => {
    if (!isShowingError) {
        Message.closeAll()
        Message({ type: 'error', message: msg })
        isShowingError = true
        setTimeout(() => {
            isShowingError = false
        }, 3000)
    }
}

export async function request(params) {
    const service = axios.create({
        baseURL: env.ApiUrl,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        timeout: 30000
    })

    service.interceptors.request.use(
        async (config) => {
            //进度条开启
            nprogress.start()
            const { TOKEN, TIMESTAMP, NONESTR, SIGNATURE, VERSION, visitorId } = await getHeaderSignature()

            config.headers.vi = visitorId
            config.headers.tk = TOKEN
            config.headers.ts = TIMESTAMP
            config.headers.ns = NONESTR
            config.headers.vn = VERSION
            config.headers.sg = SIGNATURE
            config.headers.unisysid = getUnisysid()

            return config
        },
        (err) => {
            return Promise.reject(err)
        }
    )

    service.interceptors.response.use(
        async (res) => {
            //进度条结束
            nprogress.done()
            const code = Number(res.data.code)

            if (code == 1003 || code == 1008) {
                location.reload()
                return Promise.reject(res.data)
            } else if (code == 200) {
                return res.data
            } else if (code == 2001) {
                // 未登录或登录过期
                showErrorOnce(res.data.msg)

                // 清除用户信息和token
                VueCookies.remove('token')
                VueCookies.remove('userInfo')
                VueCookies.remove('activePath')
                VueCookies.remove('activeIndex')
                // VueCookies.remove('unisysid')
                VueCookies.remove('menuItem')
                VueCookies.remove('tabList')
                VueCookies.remove('ticket')
                // VueCookies.remove('visitorRes')

                // 清除模型相关缓存
                VueCookies.remove('currentModel')
                VueCookies.remove('modelList')
                store.commit('setCurrentModel', null)
                store.commit('setModelList', [])
                store.commit('setTokenCount', null)

                // 清除音乐数据
                store.commit('music/setMusicData', { module: 'pureMusic', data: [] })
                store.commit('music/setMusicData', { module: 'VoiceMusic', data: [] })

                // 重置播放器状态
                store.commit('music/setPlaylist', [])
                store.commit('music/setCurrentSong', null)
                store.commit('music/setPlayingState', false)
                store.commit('music/setCurrentIndex', -1)

                // 清除 store 状态
                store.commit('renewUserInfo', {})
                store.commit('changeActivePath', '')
                store.commit('changeActiveIndex', '')
                store.commit('renewMenuItem', {})

                if (router.currentRoute.path != '/uni_web_login') {
                    toUniLogin({ hasDialog: false })
                }
                return Promise.reject(res.data)
            } else if (code == 1005) {
                try {
                    await getuserVid()
                } catch (error) {
                    console.warn(error)
                }
                return Promise.reject(res.data)
            } else if (code == 2007) {
                return Promise.reject(res.data)
            } else if (code == 2008) {
                VueCookies.set('orgSwitchStatus', true)
                return res.data
            } else if (code == 2009) {
                // 访客信息失效，清除存储的访客信息并重新获取后自动重试原请求
                if (!isHandling2009) {
                    isHandling2009 = true
                    VueCookies.remove('visitorRes')
                    // 创建一个 Promise 供并发请求等待
                    pending2009Promise = getuserVid()
                        .then(() => {
                            isHandling2009 = false
                            pending2009Promise = null
                        })
                        .catch((error) => {
                            console.error('getuserVid 失败', error)
                            isHandling2009 = false
                            pending2009Promise = null
                            throw error
                        })
                }
                // 等待访客信息获取完成后重试
                try {
                    if (pending2009Promise) {
                        await pending2009Promise
                    }
                    // 重新发起原请求
                    return service(res.config)
                } catch (error) {
                    return Promise.reject(res.data)
                }
            } else if (code == 1001 || code == 1004) {
                Message.closeAll()
                Message({ type: 'error', message: res.data.msg })
                return Promise.reject(res.data)
            } else {
                Message.closeAll()
                Message({ type: 'error', message: res.data.msg })
                return Promise.reject(res.data)
            }
        },
        (err) => {
            nprogress.done()
            httpErrorStatusHandle(err)
            return Promise.reject(err)
        }
    )
    return service(params)
}

function getuserVid() {
    return new Promise(async (resolve, reject) => {
        if (userVidState) {
            reject(new Error('访客信息获取中'))
            return
        }

        userVidState = true

        try {
            const { TOKEN, TIMESTAMP, NONESTR, SIGNATURE, VERSION, visitorId } = await getHeaderSignature()
            axios({
                url: `${env.ApiUrl}/web/login/getVisitorInfo`,
                headers: {
                    'Content-Type': 'application/json',
                    tk: TOKEN,
                    ts: TIMESTAMP,
                    ns: NONESTR,
                    sg: SIGNATURE,
                    vi: visitorId,
                    vn: VERSION,
                    unisysid: getUnisysid()
                },
                method: 'POST',
                timeout: 30000,
                data: { terminalType: 1 }
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        const visitorData = res.data.data
                        VueCookies.set('visitorRes', visitorData, 0)
                        store.commit('updateVisitorData', visitorData)
                        resolve(visitorData)
                    } else {
                        reject(res.data)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    setTimeout(() => {
                        userVidState = false
                    }, 3000)
                })
        } catch (error) {
            userVidState = false
            reject(error)
        }
    })
}


/**
 * 异常处理
 * @param {*} err
 */
function httpErrorStatusHandle(err) {
    let errMsg = err?.response?.data?.msg || err.message

    if (errMsg.indexOf('timeout') != -1) {
        errMsg = '请求超时'
    }

    Message.closeAll()
    Message({
        type: 'error',
        message: errMsg,
        grouping: true
    })
}

// 导出获取访客信息函数
export { getuserVid }